<div class="post-footer">
  <div class="post-footer__content">
    <ng-content />
  </div>
</div>
